import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { IsArray, IsBoolean, IsOptional, IsUUID, Matches, ValidateIf, ValidateNested } from 'class-validator';
import { OrderAttachmentRequest } from './OrderAttachmentRequest';
import { OrderRequest } from './OrderRequest';
/**
 * Request to place a group order.
 * Handles placing both single and multi-day orders.
 */
export class PlaceOrderGroupRequest {
    constructor(orderGroupId, orders, paymentToken, saveCreditOrDebitCard, cardId, courtSystemId, attachments, costWaiverRequested) {
        this.orderGroupId = orderGroupId;
        this.orders = orders;
        this.paymentToken = paymentToken;
        this.saveCreditOrDebitCard = saveCreditOrDebitCard;
        this.cardId = cardId;
        this.courtSystemId = courtSystemId;
        this.attachments = attachments;
        this.costWaiverRequested = costWaiverRequested;
    }
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], PlaceOrderGroupRequest.prototype, "orderGroupId", void 0);
__decorate([
    IsArray(),
    ValidateNested(),
    Type(() => OrderRequest),
    __metadata("design:type", Array)
], PlaceOrderGroupRequest.prototype, "orders", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], PlaceOrderGroupRequest.prototype, "courtSystemId", void 0);
__decorate([
    IsOptional(),
    Matches(/^tok_.+/),
    __metadata("design:type", Object)
], PlaceOrderGroupRequest.prototype, "paymentToken", void 0);
__decorate([
    IsBoolean(),
    ValidateIf(o => o.paymentToken),
    __metadata("design:type", Object)
], PlaceOrderGroupRequest.prototype, "saveCreditOrDebitCard", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", Object)
], PlaceOrderGroupRequest.prototype, "cardId", void 0);
__decorate([
    Type(() => OrderAttachmentRequest),
    IsArray(),
    __metadata("design:type", Array)
], PlaceOrderGroupRequest.prototype, "attachments", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], PlaceOrderGroupRequest.prototype, "costWaiverRequested", void 0);
